/* =====================================================================
   Balleh — quick view (eye icon → product modal)
   Mirrors the frontend ProductPopup: image + title + description + price +
   product code + quantity stepper + add-to-cart + view-details + buy-now.
   Reuses theme.js overlays (Balleh.openOverlay / closeAllOverlays / cart).
   ===================================================================== */
(function () {
  'use strict';
  const B = window.Balleh || {};
  const t = (k, fallback) => (B.strings && B.strings[k]) || fallback || '';
  const modal = document.querySelector('[data-quickview-modal]');
  const content = modal && modal.querySelector('[data-quickview-content]');
  if (!modal || !content) return;

  const esc = (s) => (s == null ? '' : String(s)).replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (cents) => (B.formatMoney ? B.formatMoney(cents) : ((Number(cents) || 0) / 100).toFixed(2));
  const sar = () => (B.assets && B.assets.sar_symbol_url)
    ? `<span class="sar-symbol"><img src="${B.assets.sar_symbol_url}" alt="ر.س" width="16" height="16"></span>` : '';

  let current = null;   // { variantId, url, available }
  let qty = 1;

  function priceHtml(p) {
    const hasSale = p.compare_at_price && p.compare_at_price > p.price;
    let html = `<span class="quickview__price">${money(p.price)} ${sar()}</span>`;
    if (hasSale) html += `<span class="quickview__price-compare">${money(p.compare_at_price)} ${sar()}</span>`;
    return html;
  }

  function render(p) {
    const variant = (p.variants || []).find((v) => v.available) || (p.variants || [])[0] || {};
    current = { variantId: variant.id, url: p.url, available: !!variant.available };
    const img = p.featured_image || (p.images && p.images[0]) || '';
    const sku = variant.sku || '';
    const addLabel = current.available ? t('product.add_to_cart', 'أضف للسلة') : t('product.sold_out', 'نفد من المخزون');

    content.innerHTML = `
      <div class="quickview__media">
        <a href="${esc(p.url)}">${img ? `<img src="${esc(img)}" alt="${esc(p.title)}" loading="lazy">` : ''}</a>
      </div>
      <div class="quickview__info">
        <h3 class="quickview__title" id="QuickViewTitle">${esc(p.title)}</h3>
        <div class="quickview__desc" dir="rtl">${p.description || ''}</div>
        <div class="quickview__prices">${priceHtml(p)}</div>
        ${sku ? `<p class="quickview__sku">${t('product.product_code', 'كود المنتج')} : ${esc(sku)}</p>` : ''}
        <div class="quickview__buy">
          ${current.available ? `
          <div class="quickview__qty">
            <button type="button" class="quickview__qty-btn" data-qty-dec aria-label="${t('cart.decrease_quantity', 'تقليل الكمية')}">&minus;</button>
            <span class="quickview__qty-val" data-qty-val aria-live="polite">1</span>
            <button type="button" class="quickview__qty-btn" data-qty-inc aria-label="${t('cart.increase_quantity', 'زيادة الكمية')}">+</button>
          </div>` : ''}
          <button type="button" class="quickview__add" data-quickview-add ${current.available ? '' : 'disabled'}>${addLabel}</button>
        </div>
        <div class="quickview__links">
          <a href="${esc(p.url)}" class="quickview__details">${t('product.view_details', 'عرض التفاصيل')}</a>
          ${current.available ? `<button type="button" class="quickview__buynow" data-quickview-buynow>${t('product.buy_now', 'شراء الآن')}</button>` : ''}
        </div>
      </div>`;
  }

  async function open(handle) {
    qty = 1;
    content.innerHTML = `<div class="quickview__loading" role="status">…</div>`;
    if (B.openOverlay) B.openOverlay(modal);
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error('not found');
      render(await res.json());
    } catch (e) {
      content.innerHTML = `<div class="quickview__loading">${t('cart.error_generic', 'حدث خطأ')}</div>`;
    }
  }

  function setQty(n) {
    qty = Math.max(1, n);
    const el = content.querySelector('[data-qty-val]');
    if (el) el.textContent = qty;
  }

  async function addToCart(checkout) {
    if (!current || !current.variantId) return;

    // Buy now: submit a native POST to /cart/add with return_to=/checkout so the server
    // adds the item and 302-redirects to checkout in one request. Setting window.location
    // to '/checkout' right after an AJAX add raced the cart cookie on Chrome for Android
    // and bounced the shopper back to the homepage before checkout finished loading.
    if (checkout) {
      const f = document.createElement('form');
      f.method = 'post';
      f.action = (B.routes && B.routes.cart_add_url) || '/cart/add';
      f.hidden = true;
      const add = (name, value) => {
        const i = document.createElement('input');
        i.type = 'hidden'; i.name = name; i.value = value;
        f.appendChild(i);
      };
      add('id', current.variantId);
      add('quantity', qty);
      add('return_to', '/checkout');
      document.body.appendChild(f);
      f.submit();
      return;
    }

    const btn = content.querySelector('[data-quickview-add]');
    const original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    try {
      const res = await fetch((B.routes && B.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ id: current.variantId, quantity: qty })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'add failed');
      if (B.fetchCart && B.updateBadge) { const cart = await B.fetchCart(); B.updateBadge(cart.item_count); }
      if (B.refreshCartDrawer) await B.refreshCartDrawer();
      if (B.closeAllOverlays) B.closeAllOverlays();
      if (B.openCart) B.openCart();
    } catch (err) {
      if (B.toast) B.toast(err.message || t('cart.error_generic', 'حدث خطأ'));
      if (btn) { btn.disabled = false; btn.textContent = original; }
    }
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-quickview]');
    if (trigger) { e.preventDefault(); open(trigger.getAttribute('data-quickview')); return; }
    if (e.target.closest('[data-quickview-close]')) { e.preventDefault(); if (B.closeAllOverlays) B.closeAllOverlays(); return; }
    // Backdrop click (the .quickview container sits above the scrim, so close it here).
    if (e.target === modal) { if (B.closeAllOverlays) B.closeAllOverlays(); return; }
    if (!modal.contains(e.target)) return;
    if (e.target.closest('[data-qty-inc]')) setQty(qty + 1);
    else if (e.target.closest('[data-qty-dec]')) setQty(qty - 1);
    else if (e.target.closest('[data-quickview-add]')) addToCart(false);
    else if (e.target.closest('[data-quickview-buynow]')) addToCart(true);
  });
})();
